<script>
    import { Input } from "sveltestrap";
    import { scale } from "svelte/transition";
    import { createEventDispatcher } from "svelte";
    import { _log } from "./utils/logger";
    import l from "./utils/locale";

    const dispatch = createEventDispatcher();
    export let arr = [];
    export let color = "darkgreen-item";
    export let options = {};
    let isChecked = true;
    function menuCheckboxCropItemHandler(e) {
        const checked = e.target.checked;
        const _name = e.target.name;
        dispatch("change", { checked, name: _name });
    }

    function uncheckAll() {
        _log("uncheckAll", options.find);
        if (options.find) {
            for (const item of arr) {
                if (options.find.has(item)) {
                    options.find.delete(item);
                    isChecked = false;
                }
            }
        }
        _log("uncheckAll", options.find);
        dispatch("changeFind", { find: options.find });
    }
</script>

<div
    class={`flex-center ${color} crop-item`}
    transition:scale={{ duration: 300 }}
>
    <div
        class:disabled={!isChecked}
        class="app-uncheck-all"
        on:click={uncheckAll}
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["unckeck_all"]}</title><path
                fill="none"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                d="M400 256H112"
            /></svg
        >
    </div>
    {#each arr as item}
        <Input
            class="noselect checkbox"
            on:change={menuCheckboxCropItemHandler}
            name={item}
            label={l[item]}
            type="checkbox"
            checked={isChecked}
        />
    {/each}
</div>
